export default class MapCharacterDefinition {
    constructor(id, location, imageId) {
        this._id = id;
        this._location = location;
        this._imageId = imageId;
    }

    get id() {
        return this._id;
    }

    get location() {
        return this._location;
    }

    get imageId() {
        return this._imageId;
    }
}